import React from 'react';
import FormLinksList from '@/forms/components/FormLinksList';
import selectors from '../hooks/selectors';
import events from '../hooks/events';

const RequestLinksList = ({
  category,
  className,
  code,
  field,
  text = [],
}) => {
  const { canEdit, sections } = selectors.useRequestLinksList({ category, code });
  const addItem = events.useAddRequestLink(category, { code });
  const showItem = events.useShowRequestLinks(category, { code });

  return (
    <FormLinksList
      addItem={() => addItem({ activeFieldName: field.name, sections })}
      canEdit={canEdit}
      className={className}
      code={code}
      entity="request.link"
      field={field}
      showItem={(index) => showItem({ activeFieldName: field.name, activeIndex: index, sections })}
      text={Array.isArray(text) ? text : []}
    />
  );
};

export default RequestLinksList;
